"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/system/Box"));
exports.default = (0, styles_1.styled)((Box_1.default))(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return ({
        width: theme.spacing(2),
        height: theme.spacing(2),
        backgroundColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        // opacity: 0.5,
        // borderRadius: 4,
        borderLeft: "3px solid ".concat((_c = theme.palette.azzurro) === null || _c === void 0 ? void 0 : _c.main),
        borderRight: "3px solid ".concat((_d = theme.palette.azzurro) === null || _d === void 0 ? void 0 : _d.main),
        marginRight: theme.spacing(1),
    });
});
